export const Utils = {
  parseDateStringToDate: (dateString: string): Date => {
    const parts = dateString.match(/(\d+)/g);
    if (parts) {
      if (dateString.includes('/')) {
        return new Date(
          Number(parts[2]),
          Number(parts[0]) - 1,
          Number(parts[1]),
        );
      }
      return new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
    }
    return new Date();
  },
};
